import { useState, memo } from 'react';
import { defaultUserIcon } from '../../../../constants/icons';

function UserImage({ src, title, defaultIcon }) {
  const [hasError, setHasError] = useState(false);

  return (
    <>
      {src?.length > 0 && !hasError ? (
        <img
          src={src}
          alt={title}
          title={title ? title : ''}
          onError={() => setHasError(true)}
        />
      ) : (
        <>{defaultIcon ? defaultIcon : defaultUserIcon}</>
      )}
    </>
  );
}
export default memo(UserImage);
